const C = {
  name: "Save",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 3C0 1.34315 1.34315 0 3 0H14.1716C14.9672 0 15.7303 0.31607 16.2929 0.87868L19.1213 3.70711C19.6839 4.26972 20 5.03278 20 5.82843V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V3ZM6 18H14V11H6V18ZM16 18V10C16 9.44771 15.5523 9 15 9H5C4.44772 9 4 9.44771 4 10V18H3C2.44772 18 2 17.5523 2 17V3C2 2.44772 2.44772 2 3 2H4V6C4 6.55228 4.44772 7 5 7H12C12.5523 7 13 6.55228 13 6V2H14.1716C14.4368 2 14.6911 2.10536 14.8787 2.29289L17.7071 5.12132C17.8946 5.30886 18 5.56321 18 5.82843V17C18 17.5523 17.5523 18 17 18H16ZM6 2H11V5H6V2Z" fill="currentColor"/>
    </g>
    `
};
export {
  C as Save
};
